module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-3_FI-a577ea0771e76804ab507db1ca0259d4.svg";